import { render, staticRenderFns } from "./ElTitle.vue?vue&type=template&id=02b64c9c&scoped=true"
import script from "./ElTitle.vue?vue&type=script&lang=js"
export * from "./ElTitle.vue?vue&type=script&lang=js"
import style0 from "./ElTitle.vue?vue&type=style&index=0&id=02b64c9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b64c9c",
  null
  
)

export default component.exports